var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-counter",class:{ 'badge-counter--one-digit': _vm.hasOneDigitOnly }},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }